import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ChatMessageRatingEnum } from 'src/app/moov-common/services/chat/chat-data';
import { AccountTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
})
export class ChatMessageComponent extends BaseComponent {
  @Input() isUserMessage: boolean = false;
  @Input() isLiveMessage: boolean = false;
  @Input() messageText: string = '';
  @Input() userRating: ChatMessageRatingEnum = ChatMessageRatingEnum.NATURAL;
  @Output() messageLikedEvent = new EventEmitter();
  @Output() messageDislikedEvent = new EventEmitter();

  chatMessageRatingEnum = ChatMessageRatingEnum;
  isB2C: boolean = false;
  copied: boolean = false;

  constructor(private clipboard: Clipboard) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isB2C = this.user?.accountType === AccountTypeEnum.CAREER_INDEPENDENT || this.user?.accountType === AccountTypeEnum.CAREER_INDEPENDENT_US;
  }

  messageLiked(): void {
    this.messageLikedEvent.emit();
  }

  messageDisliked(): void {
    this.messageDislikedEvent.emit();
  }

  copyMessage(): void {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.messageText;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    this.clipboard.copy(plainText.trim());
    this.copied = true;
    setTimeout(() => this.copied = false, 2000);
  }
}
